<template>
  <div class="page regulation__page">
    <div class="page__hd">
      <h1 class="page__title">{{form.main.cs_title}}</h1>
      <p class="page__desc">
        <span v-format="'yyyy-MM-dd'">{{form.main.cs_date}}</span>
        &nbsp;{{form.main.creatorName}}
      </p>
    </div>
    <div class="page__bd" v-html="form.main.cs_content"></div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/oa/companysystem"
    };
  }
};
</script>

<style>
.regulation__page {
  background: #fff;
}
.regulation__page .page__hd {
  padding: 20px;
  text-align: center;
}
.regulation__page .page__title {
  font-weight: normal;
}
.regulation__page .page__desc {
  color: #888;
}
.regulation__page .page__bd {
  padding: 0 20px;
}
</style>